export default __webpack_public_path__ + "static/media/feature_bonusrounds.50aafed8.jpg";